export const intelligemsFullThemeSnippet = `<script>
    window.Shopify = window.Shopify || {theme: {id: {{ theme.id }}, role: '{{ theme.role }}' } };
    window._template = {
        directory: "{{ template.directory }}",
        name: "{{ template.name }}",
        suffix: "{{ template.suffix }}"
    };
  </script>`;

export const IgScript = (orgId: string) =>
  `<script type="module" blocking="render" fetchpriority="high" src="https://cdn.intelligems.io/esm/${orgId}/bundle.js" async></script>`;

export const FullIgScript = (orgId: string) =>
  `${intelligemsFullThemeSnippet}
  ${IgScript(orgId)}`;
